import GroupFactory from '@/Factories/GroupFactory';
import { IAsyncElementProvider, IAsyncTupleProvider } from '#/DefaultViewExtensionInterfaces';
import AsyncControl from '@/Controls/AsyncControl';
import ControlTuple from '@/Controls/ControlTuple';
import GroupFactoryTuple from '@/Factories/GroupFactoryTuple';

export default abstract class AsyncGroupFactory extends GroupFactory implements IAsyncElementProvider, IAsyncTupleProvider<GroupFactoryTuple> {
    public async getElementAsync(): Promise<JQuery<HTMLElement>> {
        if (this.jqueryControl != null)
            return this.jqueryControl;

        this.viewModel = this.createViewModel();
        this.control = this.createControl();

        let tuple: ControlTuple;
        if (this.control instanceof AsyncControl) {
            tuple = await this.control.getTupleAsync();
        } else {
            tuple = this.control.getTuple();
        }
        return tuple.control;
    }

    public async getTupleAsync(): Promise<GroupFactoryTuple> {
        if (this.tuple)
            return this.tuple;

        const $control = await this.getElementAsync();
        this.tuple = new GroupFactoryTuple(this, $control);
        return this.tuple;
    }
}